import { IconLabelOutline18 as BadgeIcon } from "nucleo-ui-outline-18"

import type { BadgeColor } from "@productlane/lib/src/tiptap/extensions/mintlify/badge-html"
import {
	BADGE_COLORS,
	DEFAULT_BADGE_COLOR,
} from "@productlane/lib/src/tiptap/extensions/mintlify/badge-html"

import type {
	CustomBodyParams,
	SlashCommandCustomBodyElement,
	SlashCommandDefinition,
} from "../../types"
import { iconClassName } from "../../constants"

type BadgeCustomProps = CustomBodyParams & {
	color?: BadgeColor
}

const label = (color: string) =>
	(color.charAt(0).toUpperCase() + color.slice(1)).replace(/-/g, " ")

const BadgeColorBody: SlashCommandCustomBodyElement<BadgeCustomProps> = ({
	submit,
}) => (
	<div className="flex flex-wrap gap-1.5">
		{BADGE_COLORS.map((color) => (
			<button
				key={color}
				type="button"
				onClick={() => submit({ color })}
				className="rounded-[10px] p-0.5 outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
			>
				<span
					data-type="badge"
					data-color={color}
					data-size="sm"
					data-shape="rounded"
					className="pl-badge"
				>
					{label(color)}
				</span>
			</button>
		))}
	</div>
)

export const badgeCommand: SlashCommandDefinition<BadgeCustomProps> = {
	key: "badge",
	title: "Badge",
	bodyTitle: "Badge color",
	icon: <BadgeIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range, customBodyParams }) => {
		editor
			.chain()
			.focus()
			.deleteRange(range)
			.insertBadge("Badge", {
				color: customBodyParams?.color ?? DEFAULT_BADGE_COLOR,
			})
			.run()
	},
	customBody: BadgeColorBody,
	group: "blocks",
	aliases: ["badge", "label", "tag", "pill", "status"],
}
